/**
* Do not edit directly
* Generated on Tue, 29 Aug 2023 17:06:41 GMT
*/

module.exports = {
  "core": {
    "colors": {
      "transparent": "transparent",
      "current": "currentColor",
      "white": "#fff",
      "black": "#000",
      "whiteAlpha": {
        "50": "rgba(255, 255, 255, 0.04)",
        "100": "rgba(255, 255, 255, 0.06)",
        "200": "rgba(255, 255, 255, 0.08)",
        "300": "rgba(255, 255, 255, 0.16)",
        "400": "rgba(255, 255, 255, 0.24)",
        "500": "rgba(255, 255, 255, 0.36)",
        "600": "rgba(255, 255, 255, 0.48)",
        "700": "rgba(255, 255, 255, 0.64)",
        "800": "rgba(255, 255, 255, 0.80)",
        "900": "rgba(255, 255, 255, 0.92)"
      },
      "blackAlpha": {
        "50": "rgba(0, 0, 0, 0.04)",
        "100": "rgba(0, 0, 0, 0.06)",
        "200": "rgba(0, 0, 0, 0.08)",
        "300": "rgba(0, 0, 0, 0.16)",
        "400": "rgba(0, 0, 0, 0.24)",
        "500": "rgba(0, 0, 0, 0.36)",
        "600": "rgba(0, 0, 0, 0.48)",
        "700": "rgba(0, 0, 0, 0.64)",
        "800": "rgba(0, 0, 0, 0.80)",
        "900": "rgba(0, 0, 0, 0.92)"
      },
      "pink": {
        "50": "#fff2f5",
        "100": "#ffeaf0",
        "200": "#ffdde7",
        "300": "#ffb5cc",
        "400": "#fd679a",
        "500": "#ca0d67",
        "600": "#ad0054",
        "700": "#900044",
        "800": "#780036",
        "900": "#500022"
      },
      "red": {
        "50": "#fff3f1",
        "100": "#ffebe8",
        "200": "#ffdfda",
        "300": "#ffb8af",
        "400": "#f57469",
        "500": "#cb2123",
        "600": "#b3000f",
        "700": "#940000",
        "800": "#7c0000",
        "900": "#520000"
      },
      "orange": {
        "50": "#fff2e7",
        "100": "#ffecdb",
        "200": "#ffe1c6",
        "300": "#ffbc85",
        "400": "#e78033",
        "500": "#a2520f",
        "600": "#8a4407",
        "700": "#723703",
        "800": "#5f2c01",
        "900": "#3e1b00"
      },
      "yellow": {
        "50": "#fff4d5",
        "100": "#ffefbf",
        "200": "#ffe59a",
        "300": "#ecc626",
        "400": "#c99100",
        "500": "#9a5800",
        "600": "#874600",
        "700": "#743601",
        "800": "#642902",
        "900": "#451502"
      },
      "green": {
        "50": "#e4fae4",
        "100": "#d5f8d6",
        "200": "#bff4c1",
        "300": "#71e07b",
        "400": "#00b434",
        "500": "#00790e",
        "600": "#006606",
        "700": "#005402",
        "800": "#004501",
        "900": "#002c00"
      },
      "teal": {
        "50": "#eef7f7",
        "100": "#e3f3f1",
        "200": "#d0ebe9",
        "300": "#99d4cf",
        "400": "#4fa9a3",
        "500": "#21736f",
        "600": "#17615d",
        "700": "#0f504c",
        "800": "#09423e",
        "900": "#032a28"
      },
      "cyan": {
        "50": "#eef7fb",
        "100": "#e3f2fa",
        "200": "#d2ebf8",
        "300": "#98d1ec",
        "400": "#4ea5ca",
        "500": "#207090",
        "600": "#155e7a",
        "700": "#0d4d65",
        "800": "#083f54",
        "900": "#032837"
      },
      "blue": {
        "50": "#eef7ff",
        "100": "#e2f2ff",
        "200": "#d1eaff",
        "300": "#97cfff",
        "400": "#4a9ff2",
        "500": "#1a6bb1",
        "600": "#105998",
        "700": "#08497f",
        "800": "#043c6a",
        "900": "#012546"
      },
      "purple": {
        "50": "#f5f3ff",
        "100": "#f2eeff",
        "200": "#e8e2ff",
        "300": "#d1c1ff",
        "400": "#ab85ff",
        "500": "#8033f9",
        "600": "#7111e6",
        "700": "#5d00c5",
        "800": "#4c00a6",
        "900": "#310070"
      },
      "gray": {
        "50": "#f5f5f6",
        "100": "#f0eff0",
        "200": "#e6e6e7",
        "300": "#c9c9cb",
        "400": "#9b9b9e",
        "500": "#69676d",
        "600": "#58565c",
        "700": "#48464d",
        "800": "#3b3941",
        "900": "#25242b"
      }
    }
  }
}